export default __webpack_public_path__ + "static/media/i3.1f998f36.jpg";